import React from 'react';

const defaultBreakpoints = { s: 300, m: 750, l: 1100 };

const BreakpointsContext = React.createContext(defaultBreakpoints);
const {
  Provider: BreakpointsProvider,
  Consumer: BreakpointsConsumer
} = BreakpointsContext;

/** Receives 'breakpoints' object via render props from `Breakpoints` component
 * @param {object} breakpoints object containing breakpoints
 *
 * @property {number} breakpoints.s - small breakpoint (units are px)
 * @property {number} breakpoints.m - medium breakpoint (units are px)
 * @property {number} breakpoints.l - large breakpoint (units are px)
 *
 * @property {boolean} breakpoints.isDefaultSize - window width is smaller than 's' breakpoint
 * @property {boolean} breakpoints.isS - window width is between 's' and 'm' breakpoints
 * @property {boolean} breakpoints.isM - window width is between 'm' and 'l' breakpoints
 * @property {boolean} breakpoints.isL - window width is greater than 'l' breakpoint
 *
 * @property {number} breakpoints.heightWindow - innerHeight of window (units are px)
 * @property {number} breakpoints.widthWindow - innerWidth of window (units are px)
 *
 * @property {number} breakpoints.heightScreen - height of the physical screen (units are px, not available in all browsers)
 * @property {number} breakpoints.widthScreen - width of the physical screen (units are px, not available in all browsers)
 *
 * @property {boolean} breakpoints.landscapeWindow - height to width ratio of window is horizontal
 * @property {boolean} breakpoints.portraitWindow - height to width ratio of window is vertical
 *
 * @property {boolean} breakpoints.landscapeScreen - orientation of physical screen is horizontal (not available for all browsers)
 * @property {boolean} breakpoints.portraitScreen - orientation of physical screen is vertical (not available for all browsers)*/
export {
  BreakpointsProvider,
  BreakpointsConsumer,
  BreakpointsContext,
  defaultBreakpoints
};
